module.exports = __webpack_public_path__ + "img/icon_item6.b697c276.png";